module.exports = __webpack_public_path__ + "static/media/tongrolletjes.2d079fa1.jpg";